<template>
  <!-- بدنه تب ها -->
  <div class="tab-content rounded bg-white shadow z-depth-1 p-2">
    <!-- بدنه سند شماره یک -->
    <div
      v-for="(tab, index) in tabList"
      :key="tab.TabID"
      class="tab-pane fade w-100 p-3"
      :class="{ 'show active': index == 0 }"
      :id="tabID(tab.TabID)"
    >
      <KeepAlive>
        <!-- پاس دادن شناسه تب و تب فعال و کلید میانبر به کامپاننت تب -->
        <NewAccDoc
          v-if="tab.TabContent === 'AccDoc'" 
          v-bind:tabActive="tabActive" 
          v-bind:tabData="tab"
        ></NewAccDoc>
        <!-- نمایش لیست سندها -->
        <ListDocInfo 
          v-if="tab.TabContent === 'ListDocInfo'"
        ></ListDocInfo>
        <!-- نمایش میزکار مدیر -->
        <dashboard-user
          v-if="tab.TabContent === 'Dashboard'"
        ></dashboard-user>
        <!-- نمایش لیست کاربران -->
        <list-user-info 
          v-if="tab.TabContent === 'ListUserInfo'"
          v-bind:tabID="tabActive"
        ></list-user-info>
        <!-- نمایش طرف حساب ها -->
        <list-taraf-hesabha 
          v-if="tab.TabContent === 'ListTarafHesabha'"
        ></list-taraf-hesabha>
        <!-- نمایش لیست سرفصل حساب ها -->
        <list-base-acc
          v-if="tab.TabContent === 'ListBaseAcc'"
        >
        </list-base-acc>
        <!-- نمایش لیست مراکز هزینه -->
        <list-base-use-place
          v-if="tab.TabContent === 'ListBaseUsePlace'"
        ></list-base-use-place>
        <ListTabagheBandiAmaliyati
          v-if="tab.TabContent === 'ListTabagheBandiAmaliyati'"
        ></ListTabagheBandiAmaliyati>
        <ReportTarazname
          v-if="tab.TabContent === 'ReportTarazname'"
        ></ReportTarazname>
        <ReportSelectDocument
          v-if="tab.TabContent === 'ReportSelectDocument'"
        ></ReportSelectDocument>
        <Budgeting
          v-if="tab.TabContent === 'Budgeting'"
        ></Budgeting>
        <ActivityList
          v-if="tab.TabContent === 'ActivityList'"
        ></ActivityList>
        <SettingApp
          v-if="tab.TabContent === 'SettingApp'"
        ></SettingApp>
        <ManageBlockIP
          v-if="tab.TabContent === 'ManageBlockIP'"
        ></ManageBlockIP>   
      </KeepAlive>
    </div>
  </div>
</template>

<script>
import NewAccDoc from "../NewAccDoc/NewAccDoc.vue";
import ListDocInfo from '../ListDocInfo/ListDocInfo.vue'
import Dashboard from '../Dashboard/Dashboard.vue'
import ListUserInfo from '../ListUserInfo/ListUserInfo.vue'
import ListTarafHesabha from '../ListTarafHesabha/ListTarafHesabha.vue'
import ListBaseAcc from '../ListBaseAcc/ListBaseAcc.vue'
import ListBaseUsePlace from '../ListBaseUsePlace/ListBaseUsePlace.vue'
import ListTabagheBandiAmaliyati from '../ListTabagheBandiAmaliyati/ListTabagheBandiAmaliyati.vue'
import ReportTarazname from '../ReportTarazname/ReportTarazname.vue'
import ReportSelectDocument from '../ReportSelectDocument/ReportSelectDocument.vue'
import Budgeting from '../Budgeting/Budgeting.vue'
import ActivityList from '../ActivityList/ActivityList.vue'
import SettingApp from '../SettingApp/SettingApp.vue'
import ManageBlockIP from '../ManageBlockIP/ManageBlockIP.vue'

export default {
  components: {
    NewAccDoc: NewAccDoc,
    ListDocInfo: ListDocInfo,
    DashboardUser: Dashboard,
    ListUserInfo: ListUserInfo,
    ListTarafHesabha: ListTarafHesabha,
    ListBaseAcc: ListBaseAcc,
    ListBaseUsePlace: ListBaseUsePlace,
    ListTabagheBandiAmaliyati: ListTabagheBandiAmaliyati,
    ReportTarazname: ReportTarazname,
    ReportSelectDocument: ReportSelectDocument,
    Budgeting: Budgeting,
    ActivityList: ActivityList,
    SettingApp: SettingApp,
    ManageBlockIP: ManageBlockIP,
  },
  computed: {
    tabList() {
      return this.$store.getters.getTabList;
    },
  },
  props: {
    // پراپرتی دریافت تب اکتیو
    tabActive : {type: Number},
  },
  methods: {
    tabID: function (TabID) {
      return "doc" + TabID;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/TabBody/TabBody.vue